import { dataVideoCrop } from 'dls-icons-data'
import { createIcon } from '../common'

const IconVideoCrop = /*#__PURE__*/createIcon(dataVideoCrop)
export default IconVideoCrop
